import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { Text } from "../Text";
var cx = classNames.bind(styles);
export var PageItem = /*#__PURE__*/memo(function (_ref) {
  var onClick = _ref.onClick,
    isDots = _ref.isDots,
    isActive = _ref.isActive,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("button", {
    className: cx('item', 'reset-button', {
      'item-active': isActive,
      dots: isDots
    }),
    onClick: isDots || isActive ? undefined : function () {
      return onClick(value);
    },
    type: "submit"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "size5-m"
  }, value));
});